// extracted by mini-css-extract-plugin
export default {"root":"PopoverDialog_root__bvVsi","show":"PopoverDialog_show__cpMvs","close":"PopoverDialog_close__FJu-r","body":"PopoverDialog_body__DK2jt","scroll":"PopoverDialog_scroll__ctQCj"};